export default "__VITE_ASSET__B5EuLV0I__"